import { render, staticRenderFns } from "./EarnedPointTable.vue?vue&type=template&id=56771172&"
import script from "./EarnedPointTable.vue?vue&type=script&lang=js&"
export * from "./EarnedPointTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports